module.exports = __webpack_public_path__ + "static/media/iiw_heuschrecken_rundweg_lainzer_tiergarten.845d591f.pdf";